import { Component, OnInit, AfterViewInit, Input, ViewEncapsulation, HostListener } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import {AuthenticationService} from '../../../_services/authentication.service';

@Component({
  selector: 'pg-menu-items',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [
    trigger('toggleHeight', [
      state(
        'close',
        style({
          height: '0',
          overflow: 'hidden'
        })
      ),
      state(
        'open',
        style({
          height: '*',
          overflow: 'hidden'
        })
      ),
      transition('close => open', animate('140ms ease-in')),
      transition('open => close', animate('140ms ease-out'))
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit, AfterViewInit {
  menuItems = [];
  currentItem = null;
  currUser;
  isPerfectScrollbarDisabled = false;
  constructor(
      private authService: AuthenticationService,
  ) {
    this.currUser = this.authService.getCurrentUser();
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.togglePerfectScrollbar();
    });
  }

  @HostListener('window:resize', [])
  onResize() {
    this.togglePerfectScrollbar();
  }

  togglePerfectScrollbar() {
    this.isPerfectScrollbarDisabled = window.innerWidth < 1025;
  }

  @Input()
  set Items(value) {
    this.menuItems = value;
  }

  toggleNavigationSub(event, item) {
    event.preventDefault();
    if (this.currentItem && this.currentItem !== item) {
      this.currentItem['toggle'] = 'close';
    }
    this.currentItem = item;
    item.toggle = item.toggle === 'close' ? 'open' : 'close';
  }

  checkAvailability(menuItem): boolean {
    // return true;
    this.currUser = this.authService.getCurrentUser();

    if (!this.currUser) {
      return false;
      // currUser = this.authService.getCurrentUser();
    }
    else {

      if (!menuItem.roles || menuItem.roles.length === 0) {
        return true;
      }
      else if(this.currUser.isAdmin){
        return true;
      }
      else {
        let accessible = false;
        menuItem.roles.forEach(menuRole => {
          this.currUser.roles.forEach( userRole => {
            if(menuRole == userRole){
              accessible = true;
            }
          });
        });

        return accessible;
      }
    }

  }
}
